import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import "../App.css";
import "./TechContent.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import img1 from "../images/job.png";
import img2 from "../images/job-readiness-banner2.jpg";
import img3 from "../images/job-readiness-banner3.jpg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

function TechContent() {
  let [carousel1, setCarousel1] = useState(false);
  let [carousel2, setCarousel2] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", (event) => {
      if (window.scrollY > 1200 && window.scrollY < 1599) {
        setCarousel1(true);
        //   console.log(carousel1, "carousel1")
      } else if (window.scrollY > 1600 && window.scrollY < 2000) {
        setCarousel2(true);
        //   console.log(carousel2, "carousel2")
      } else {
        setCarousel1(false);
        setCarousel2(false);
      }
    });
  }, [window.scrollY]);

  return (
    <div className="job-readiness-container job-main-container" id="main">
      {console.log(window.scrollY, "scroll y ki valueee")}
      <title>Job Readiness - Home</title>
      <h1 className="sr-only" tabIndex={0}>
        Job Readiness
      </h1>
      <p className="sr-only">Phase of Tech Expressway-Level2</p>
      <OwlCarousel
        className="owl-theme"
        items="1"
        // autoplay
        // dots
        // loop
      >
        <div className="item">
          <img src={img1} alt="banner" />
        </div>
        {/* <div className="item">
                    <img src={img2} alt="image" />
                </div>
                <div className="item">
                    <img src={img3} alt="image" />
                </div> */}
      </OwlCarousel>
      <Navbar />
      <div className="video-content">
        <div className="video-content-row1">
          <div className="video-content1">
            <h2 class="job-readiness-title-space">
              <span>JOB READINESS</span> Overview
            </h2>
            {/*   <p>Also known as Level 2, this phase of Tech Expressway, focuses on imparting the ASEs with all that they need to become job-ready.</p>
                        <p>As part of stream learning, ASEs receive learning interventions in a specific technology/functional skill out of a wide array of available skills. The stream learning course-plan offers a mix of self-led and SME-assisted sessions along with extensive hands-on to help strengthen conceptual understanding. Modular assessments are interwoven into the course maps to allow ASEs to evaluate their learning and comprehension.</p>
                        <p>Along with stream learning, ATCI ASE Professional Advancement Program, and Delivery Foundation also run in parallel. The ATCI ASE Professional Advancement Program strives to hone soft skills in young talent through interventions on Business Communication skills, Personal Productivity & Well-Being, while Delivery Foundation prepares ASEs to work in projects by familiarizing them with project delivery practices and methodologies.</p>  */}
            <p>
              {" "}
              This phase focuses on imparting the entry level hires with all
              that they need to become job ready.
            </p>
            <p>
              {" "}
              It begins with ATCI ASE Professional Advancement Program, and
              Delivery Learning. The ATCI ASE Professional Advancement Program
              strives to hone soft skills in young talent through interventions
              in Business Communication skills, Personal Productivity &
              Well-Being. Delivery Learning prepares learners to work in
              projects by familiarizing them with software development and
              delivery practices and methodologies.
            </p>
            <p>
              {" "}
              The learners then transition into Stream Learning, where they
              receive learning interventions in a specific technology /
              functional skill assigned to them out of a wide array of available
              skills. The stream learning course-plan offers a mix of self-led
              and SME-assisted sessions along with extensive hands-on activities
              to help strengthen conceptual understanding. Modular assessments
              are interwoven into the course maps to allow learners to evaluate
              their learning and comprehension.
            </p>
            <p>
              Next, ASEs attempt MyCompetency assessment, earning proficiencies
              in the skill acquired through Stream learning.{" "}
            </p>
          </div>
        </div>
        {/* <div className="video-content-row2">
                    <div className="video-content2">
                        <br />
                        <iframe id="kmsembed-1_n75ue1lt" width="400" height="280" src="https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_n75ue1lt/uiConfId/27188232" class="kmsembed" allowfullscreen webkitallowfullscreen mozAllowFullScreen allow="autoplay *; fullscreen *; encrypted-media *" referrerPolicy="no-referrer-when-downgrade" frameborder="0" title="Kaltura Player"></iframe>
                    </div>
                </div> */}
      </div>
      <div style={{ marginTop: 0 }} className="job-readiness-journey">
        <h2>
          Entry Level Learning Journey : <span>JOB READINESS</span>{" "}
        </h2>
        {/* <h2>Tech Expressway Learning Journey : <span>JOB READINESS</span> </h2> */}
        {/* <h3><span>JOB READINESS</span> Journey</h3> */}
        <img
          src="/images/entryleveljob.png"
          className="tech-journey-img2"
          alt="journey"
        />
        {/* <img src="/images/JobReadiness/Slide2.png" className="tech-journey-img2" alt="journey" /> */}
        {/* <img src="/images/JobReadiness/Slide3.png" className="tech-journey-img" alt="journey" /> */}

        {/* <img src="/images/direct-hires-v2.png" className="tech-journey-img" alt="journey"/>
                <br/> <br/>
                <img src="/images/campus-hires-v2.png" className="tech-journey-img" alt="journey"/> */}
      </div>

      {/* <div className="job-salient-features">
                <h2 class="job-readiness-title-space">
                    Stream Learning Salient Features</h2>
                <p>As they prepare to become job-ready, ASEs with shared skills are grouped in a Cohort which is facilitated by a Cohort Champion or technology SME. The Stream learning encompasses faculty-led intensive handholding sessions that establish foundational understanding of critical concepts, self-paced learning and contact sessions with SMEs. Modular assessments designed at logical points throughout the program allow them to evaluate their learning and grow. ASEs are thus equipped to apply their learning to the projects they are tagged to.</p>
                <img src="/images/JobReadiness/Stream-Learning.png" className="stream-img" alt="stream" />
            </div> */}

      <div className="jobReadiness-carousel-container">
        <h2>
          <span>STREAM LEARNING</span>
        </h2>
        <div className="jobReadiness-carousel-wrap">
          <Carousel
            swipeable={false}
            draggable={false}
            showDots={true}
            responsive={responsive}
            // ssr={true} // means to render carousel on server-side.
            infinite={true}
            // autoPlay={this.props.deviceType !== "mobile" ? true : false}
            autoPlay={carousel1 ? true : false}
            autoPlaySpeed={8000}
            keyBoardControl={true}
            customTransition="all .5"
            transitionDuration={500}
            // containerClass="carousel-container"
            // removeArrowOnDeviceType={["tablet", "mobile"]}
            // deviceType={this.props.deviceType}
            // dotListClass="custom-dot-list-style"
            // itemClass="carousel-item-padding-40-px"
          >
            {/*   <div className='slide-holder'>
                            <h3>Learning Delivery Models</h3>
                            <img src='/images/JobReadiness/Infographic1.png' className="sliderImg2" />
                        </div>
                        <div className='slide-holder'>
                            <h3>A sample learning journey in Model 1</h3>
                            <div className="video-content-carousel">
                                <br />
                                <iframe id="kmsembed-1_n75ue1lt" width="800" height="450" src="https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_n75ue1lt/uiConfId/27188232" class="kmsembed" allowfullscreen webkitallowfullscreen mozAllowFullScreen allow="autoplay *; fullscreen *; encrypted-media *" referrerPolicy="no-referrer-when-downgrade" frameborder="0" title="Kaltura Player"></iframe>
                            </div>
                        </div> */}
            <div className="slide-holder">
              <h3 style={{ display: "block" }}>Salient Features</h3>
              <img
                src="/images/JobReadiness/Stream-Learning-latestone.png"
                className="sliderImg1"
              />
            </div>
            <div className="slide-holder">
              <h3 style={{ display: "block" }}>
                Personalized Learning Journey
              </h3>
              {/* <p>Learning path for a learner can be personalized based on their prior knowledge/ proficiency, interests and/or project needs.</p> */}
              <img
                src="/images/JobReadiness/Personalization of Stream Learning Journey_updated.png"
                className="sliderImg3"
              />
            </div>
          </Carousel>
        </div>
      </div>

      {/* <div className='jobReadiness-carousel-container two'>
                <h2><span>PERSONALIZATION OF THE STREAM LEARNING JOURNEY</span></h2>
                <div className='jobReadiness-carousel-wrap'>
                    <Carousel
                        swipeable={false}
                        draggable={false}
                        showDots={true}
                        responsive={responsive}
                        // ssr={true} // means to render carousel on server-side.
                        infinite={true}
                        autoPlay={carousel2 ? true : false}
                        autoPlaySpeed={8000}
                        keyBoardControl={true}
                        customTransition="all .5"
                        transitionDuration={500}
                    // containerClass="carousel-container"
                    // removeArrowOnDeviceType={["tablet", "mobile"]}
                    // deviceType={this.props.deviceType}
                    // dotListClass="custom-dot-list-style"
                    // itemClass="carousel-item-padding-40-px"
                    >
                        <div className='slide-holder'>
                            <p>Learning path for a learner can be personalized based on their prior knowledge/ proficiency, interests and/or project needs.</p>
                            <img src='/images/JobReadiness/Personalization of Stream Learning Journey.png' className="sliderImg3" />
                        </div>
                        <div className='slide-holder'>
                            <p>Learning journey, in Model 1, offers learners, the flexibility to sequence modules and assessments as per their own interests/ project needs.</p>
                            <img src='/images/JobReadiness/SequencingModel.png' className="sliderImg5" />
                        </div>
                        <div className='slide-holder'>
                            <p>Here is a sample illustration of personalization in Java stream learning journey, in Model 1.</p>
                            <img src='/images/JobReadiness/JAVA Learning Journey - Model with Learning and Assessmnt.png' className="sliderImg4" alt='Stream-learning-journey-infographic'>
                            </img>
                        </div>
                    </Carousel>
                </div>
            </div>
 */}
      {/* <div className='learning-journey-container'>
                <div className='learning-journey-wrap'>
                    <h2 class="job-readiness-title-space"><span>Stream Learning Journey</span> - Personalization</h2>
                    <div className='learning-journey-box'>
                        <p className='learning-journey-content'>Learning path for a learner can be personalized based on their prior knowledge/ proficiency, interests and/or project needs.
                            <img src="/images/learning-journey.png"></img>
                        </p>
                        <img src='/images/JobReadiness/Personalization of Stream Learning Journey.png' className='learning-journey-info1' alt='Stream-learning-journey-infographic'></img>
                    </div>
                    <div className='learning-journey-box box2'>
                        <h3>Sequencing of Learning Modules and Assessments</h3>
                        <h4>Choice of Sequencing Modules - <span style={{ 'font-family': 'graphik-medium' }}>Model 1</span></h4>
                        <div className='choice-content'>
                            <div className='arrow-right'></div>
                            <div className='content-box'>
                                <img src='/images/JobReadiness/icon1.png'></img>
                                <p>Stream begins with Introductory/ Foundational Modules facilitated by SME.</p>
                            </div>
                            <img src='/images/JobReadiness/arrow.png' style={{ 'margin-left': '42%' }} className='arrow'></img>
                            <div className='content-box' style={{ 'margin-left': '4%' }}>
                                <img src='/images/JobReadiness/icon2.png'></img>
                                <p>ASE can access any subsequent learning <b>module</b> in any <b>order for self-learning, based on interest or project need</b></p>
                            </div>
                            <img src='/images/JobReadiness/arrow.png' style={{ 'margin-left': '42%' }} className='arrow'></img>
                            <div className='content-box' style={{ 'margin-left': '8%' }}>
                                <img src='/images/JobReadiness/icon3.png'></img>
                                <p>SSeparate SME connect can be arranged for better understanding of prioritized/ selected modules</p>
                            </div>
                            <img src='/images/JobReadiness/arrow.png' style={{ 'margin-left': '42%' }} className='arrow'></img>
                            <div className='content-box'>
                                <img src='/images/JobReadiness/icon4.png' style={{ 'margin-left': '12%' }}></img>
                                <p><b>Sequence of MCQs</b> can be decided based on prioritized modules learnt.</p>
                            </div>
                        </div>
                    </div>
                    <div className='learning-journey-box box3'>
                        <h3>Example Representation for Model 1</h3>
                        <img src='/images/JobReadiness/JAVA Learning Journey - Model with Learning and Assessmnt.png' className='learning-journey-info3' alt='Stream-learning-journey-infographic'>
                        </img>
                    </div>
                </div>
            </div> */}
    </div>
  );
}

export default TechContent;
